module.exports = __webpack_public_path__ + "img/terminal-icon.0367444e.png";